import { gql } from '@apollo/client';
import { NSC_PROGRESSION_DATA } from '../../fragments';

export const EXPORT_FUNDER_NSC_PROGRESSION = gql`
  query ExportFunderNSCProgressionData($input: ExportArgs!) {
    exportFunderNSCProgressionData(input: $input) {
      id
      name
      class
      focusSubjects {
        id
        name
      }
      grades {
        id
        name
        value
      }
      programme {
        id
        name
      }
      serviceProviders {
        id
        name
      }
      subject {
        id
        name
        subjectGradeReference
      }
      nscProgressionData {
        ...nscProgressionData
      }
    }
  }
  ${NSC_PROGRESSION_DATA}
`;
